(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer-custom"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__mcd_custom_initialized_v3) return;
  window.__mcd_custom_initialized_v3 = true;

  function qAll(sel, root){
    root = root || document;
    try { return Array.prototype.slice.call(root.querySelectorAll(sel)); } catch(e){ return []; }
  }

  function initClose(root){
    qAll('[data-custom-close]', root).forEach(function(btn){
      if (btn.__bound) return; btn.__bound = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var r = btn.closest('[data-custom-drawer]');
        if (r) { r.style.display = 'none'; }
      });
    });
  }

  function initTabs(root){
    qAll('.mcd-tab', root).forEach(function(tab){
      if (tab.__bound) return; tab.__bound = true;
      tab.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var target = tab.getAttribute('data-tab-target'); if (!target) return;
        qAll('.mcd-tab', root).forEach(function(t){ t.classList.remove('mcd-tab--active'); t.setAttribute('aria-selected','false'); });
        qAll('.mcd-panel', root).forEach(function(p){ p.classList.remove('mcd-panel--active'); });
        tab.classList.add('mcd-tab--active'); tab.setAttribute('aria-selected','true');
        var panel = document.getElementById(target);
        if (panel) { panel.classList.add('mcd-panel--active'); panel.scrollTop = 0; }
      });
    });
  }

  function initAccordions(root){
    qAll('.mcd-acc-btn', root).forEach(function(btn){
      if (btn.__boundAcc) return; btn.__boundAcc = true;
      var submenu = btn.nextElementSibling;
      if (!submenu || submenu.tagName.toLowerCase() !== 'ul') return;

      // ensure closed state
      submenu.style.overflow = 'hidden';
      submenu.style.transition = 'max-height 220ms ease';
      submenu.style.maxHeight = 0;
      submenu.setAttribute('hidden','');

      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', (!expanded).toString());

        if (!expanded){
          // open
          submenu.removeAttribute('hidden');
          // allow layout to settle then set maxHeight
          requestAnimationFrame(function(){
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
          });
        } else {
          // close
          submenu.style.maxHeight = 0;
          setTimeout(function(){ submenu.setAttribute('hidden',''); }, 240);
        }
      });
    });
  }

  function init(root){
    initClose(root);
    initTabs(root);
    initAccordions(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);

})();
  } catch(e) { console.error(e); }
})();

})();
